import * as ProvidersDir from './providers/ngrx-store.providers';

export namespace Shared {
	export import APP_STORE_PROVIDERS = ProvidersDir.APP_STORE_PROVIDERS;
}
